// extracted by mini-css-extract-plugin
export default {"mainContainer":"dashboard_mainContainer__uGpAs","mainContent":"dashboard_mainContent__gqsgp"};